module.exports = __webpack_public_path__ + "img/add-button.f46b9e36.svg";